/**
 * Kopier-Knopf an der Blase des Entwicklers (17.10.2026, Martin 14:17: „damit ich Informationen herauskopieren kann“).
 *
 * Kopiert NUR den Text der Blase (den der Aufrufer übergibt) — nichts Privates, kein Name, keine Uhrzeit. Weg und Rückfall wie
 * beim Tippen-zum-Kopieren von `code` (lib/markdown.ts): erst die Zwischenablage-API, sonst `execCommand`. Rückmeldung: der
 * Knopf zeigt kurz ein Häkchen (Name wechselt auf „Kopiert“) und der Hinweis „In die Zwischenablage kopiert“ erscheint; geht es
 * nicht, sagt der Hinweis „Kopieren gerade nicht möglich“. Aussehen: frontend/style.css `.bubble-kopie`.
 * Echter Knopf (`button`), also per Tastatur (Tab, Enter, Leertaste) und Bildschirmleser bedienbar; Fläche 44×44.
 * Hinweis: Am Chat von Vespera gibt es seit 25.07.2026 bewusst KEINEN Kopier-Knopf (Martin: „überall wieder weg“) — dies ist
 * der einzige an Blasen; er sitzt nur an der Blase des Entwicklers (lib/entwickler-blase.ts).
 */
import { altModusKopieren } from "./markdown.js";

const NS = "http://www.w3.org/2000/svg";
const KOPIE_PFAD = "M16 1H4a2 2 0 0 0-2 2v14h2V3h12V1zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H8V7h11v14z";
const HAKEN_PFAD = "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z";
const RUHE_TEXT = "Text kopieren";

function hinweis(message: string): void {
  window.dispatchEvent(new CustomEvent("voice-v8:toast", { detail: { message, kind: "info" } }));
}

/** Schreibt `text` in die Zwischenablage. `true`, wenn es klappte. */
export async function kopiereText(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* weiter zum Rückfall */
    }
  }
  return altModusKopieren(text);
}

export function baueKopierKnopf(text: string): HTMLButtonElement {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "bubble-kopie";
  btn.setAttribute("aria-label", RUHE_TEXT);
  btn.title = RUHE_TEXT;
  const svg = document.createElementNS(NS, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("width", "18");
  svg.setAttribute("height", "18");
  svg.setAttribute("aria-hidden", "true");
  const path = document.createElementNS(NS, "path");
  path.setAttribute("fill", "currentColor");
  path.setAttribute("d", KOPIE_PFAD);
  svg.appendChild(path);
  btn.appendChild(svg);
  let zurueck: number | undefined;
  btn.addEventListener("click", (ev) => {
    ev.stopPropagation();
    void kopiereText(text).then((ok) => {
      if (!ok) {
        hinweis("Kopieren gerade nicht möglich");
        return;
      }
      path.setAttribute("d", HAKEN_PFAD);
      btn.classList.add("is-copied");
      btn.title = "Kopiert";
      btn.setAttribute("aria-label", "Kopiert");
      hinweis("In die Zwischenablage kopiert");
      window.clearTimeout(zurueck);
      zurueck = window.setTimeout(() => {
        path.setAttribute("d", KOPIE_PFAD);
        btn.classList.remove("is-copied");
        btn.title = RUHE_TEXT;
        btn.setAttribute("aria-label", RUHE_TEXT);
      }, 1400);
    });
  });
  return btn;
}
